import type { FC, HTMLProps } from "react";

import { STYLES } from "@vita-learning/styles";

import Button from "./Button";

/* Types */
import type { ButtonProps } from "./Button";

export const PrimaryButton: FC<
	Omit<HTMLProps<HTMLAnchorElement | HTMLButtonElement>, keyof ButtonProps> &
	ButtonProps
> = ({ children, ...props }) => (
	<Button
		{...props}
		color={STYLES.colors.vitas.primary}
		pseudoColor={STYLES.colors.vitas.secondary}
	>
		{children}
	</Button>
);